import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { MORE_ON_EDMUNDS_CONTENT_PATH } from 'client/data/constants/contents-paths';
import { IMAGE_SIZES } from 'site-modules/shared/constants/editorial/editorial';
import { ImageLinks } from 'site-modules/shared/components/editorial/image-links/image-links';

function MoreOnEdmundsUI({ content, isOneLine }) {
  if (!content) {
    return null;
  }

  return (
    <ImageLinks
      entry={content}
      imageSize={IMAGE_SIZES.sm}
      imagesListClassName="d-flex row mb-0"
      imageCardClassName={classnames('col-6 mb-1_5', { 'col-md-2': isOneLine, 'col-md-4': !isOneLine })}
      titleContainerClassName={null}
      titleClassName="heading-3 mb-1_5"
      imageClassName="rounded"
      imageTitleClassName="fw-bold mt-0_5 size-16 mb-0"
    />
  );
}

MoreOnEdmundsUI.propTypes = {
  content: CmsEntities.Content,
  isOneLine: PropTypes.bool,
};

MoreOnEdmundsUI.defaultProps = {
  content: null,
  isOneLine: false,
};

export const MoreOnEdmunds = connectToModel(MoreOnEdmundsUI, {
  content: bindToContent(MORE_ON_EDMUNDS_CONTENT_PATH, 'image-links'),
});
